/*
 * @Author: 张天昊
 * @Date: 2024-05-17 10:21:56
 * @LastEditTime: 2024-10-02 09:17:00
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: /Mobile/src/router/modules/itineraryUniversal.js
 */
// export default [
//   {
//     path: '/itineraryUniversal/detail/:id',
//     name: 'itineraryUniversalDetail',
//     meta: {
//         title: '行程单详情',
//         keepAlive: true
//     },
//     component: () =>
//         import (
//             /* webpackChunkName: "itineraryUniversalDetail" */
//             '../../pages/itineraryUniversal/detail.vue'
//         )
//   },
//   {
//     path: '/itineraryUniversal/detail/:id/tourists',
//     name: 'itineraryUniversalDetailTourists',
//     meta: {
//         title: '游客详情'
//     },
//     component: () =>
//         import (
//             /* webpackChunkName: "itineraryUniversalDetailTourists" */
//             '../../pages/itineraryUniversal/tourists.vue'
//         )
//   }
// ]
import NavBarLayout from '@/layout/navbar';
export default [
  {
    path: '/itineraryUniversal',
    name: 'itineraryUniversalLayout',
    component: NavBarLayout,
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: 'detail/:id',
        name: 'itineraryUniversalDetail',
        meta: {
          title: '行程单详情',
          navBar: {
            mode: 'white',
            background: '#36B374'
          },
          background: '#36B374',
          keepAlive: false
        },
        component: () =>
          import(
            /* webpackChunkName: "itineraryUniversalDetail" */
            '../../pages/itineraryUniversal/detail.vue'
          )
      },
      {
        path: 'detail/:id/tourists',
        name: 'itineraryUniversalDetailTourists',
        meta: {
          title: '游客详情',
          navBar: {}
        },
        component: () =>
          import(
            /* webpackChunkName: "itineraryUniversalDetailTourists" */
            '../../pages/itineraryUniversal/tourists.vue'
          )
      },
      {
        path: 'changeTravel',
        name: 'itineraryUniversalDetailChangeTravel',
        meta: {
          title: '其他变更',
          navBar: {}
        },
        component: () =>
          import(
            /* webpackChunkName: "itineraryUniversalDetailTourists" */
            '../../pages/itineraryUniversal/OtherChange.vue'
          )
      },
    ]
  }
];
